import { useOrganizations } from '@contexts/organizations-provider';
import { useHasPermission } from '@contexts/permissions-provider';
import { useHasCompanyDocuments } from '@features/documents/hooks/use-has-company-documents/useHasCompanyDocuments';
import { ContentLoader } from '@shared/components/content-loader/ContentLoader';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { resolveDefaultDocumentsChild } from './DocumentsIndexRedirect.utils';

const DocumentsIndexRedirect = React.memo((): React.ReactElement => {
  const { selectedOrganization } = useOrganizations();

  const hasCompanyPermission = useHasPermission(
    'CustomerTrainingDocument_View_Org'
  );
  const hasCaePermission = useHasPermission('CAETrainingDocuments_View_All');
  const hasSubmittedPermission = useHasPermission(
    'SubmittedTrainingDocuments_View_Org'
  );

  const { hasDocuments, isLoading } = useHasCompanyDocuments({
    organizationId: selectedOrganization?.id,
    enabled: hasCompanyPermission,
  });

  if (hasCompanyPermission && isLoading) {
    return <ContentLoader />;
  }

  const target = resolveDefaultDocumentsChild({
    hasCompanyDocuments: hasDocuments,
    hasCompanyPermission,
    hasCaePermission,
    hasSubmittedPermission,
  });

  if (!target) {
    return <InlineFeedback type="not-found" />;
  }

  return <Navigate to={target} replace />;
});

DocumentsIndexRedirect.displayName = 'DocumentsIndexRedirect';

export { DocumentsIndexRedirect };
